import {
  Heading,
  minimumWidth,
  pxToRem,
  styled,
  textStyle,
  ThemeColors,
} from '@feast-it/ui/light';
import { JSX } from 'react';

export const Container = styled.section<{
  backgroundColor: keyof ThemeColors;
  isDark?: boolean;
  as?: keyof JSX.IntrinsicElements;
}>`
  ${({ theme, backgroundColor, isDark }) => `
    background: ${isDark ? theme.colors.black : theme.colors[backgroundColor]};
    color: ${isDark ? theme.colors.white : 'inherit'};
    overflow: hidden;
    width: 100%;
    position: relative;

    padding: ${theme.spacing[8]} ${theme.spacing[6]};

    ${minimumWidth(theme.breakpoints.medium)} {
      padding: ${theme.spacing[10]} ${theme.spacing[8]};
    }
    ${minimumWidth(theme.breakpoints.large)} {
      padding: ${theme.spacing[14]} ${theme.spacing[20]};
    }
  `};
`;

export const Inner = styled.div`
  ${({ theme }) => `
    max-width: ${pxToRem(1280)};
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${theme.spacing[6]};

    ${minimumWidth(theme.breakpoints.medium)} {
      gap: ${theme.spacing[8]};
    }

    ${minimumWidth(theme.breakpoints.large)} {
      gap: ${theme.spacing[10]};
    }
  `}
`;

export const TextWrapper = styled.div`
  ${({ theme }) => `
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing[3]};
    text-align: center;

    ${minimumWidth(theme.breakpoints.small)} {
      gap: ${theme.spacing[4]};
    }
   `}
`;

export const StyledHeading = styled(Heading)`
  margin: 0 auto;
`;

export const DescriptionWrapper = styled.span<{
  color: keyof ThemeColors;
}>`
  ${({ theme, color }) =>
    `
    max-width: ${pxToRem(700)};
    color: ${theme.colors[color]};
    ${textStyle(theme, 'bodyMedium')};
   `};
`;
